class NostoAPILayer {
  constructor () {
    this.eventBus = window.theme.category.eventBus

    this.promos = JSON.parse(document.querySelector('[data-promos]')?.textContent) || null

    this.offset = 0

    this.waitForNostoJS().then((nostoLoaded) => {
      if (nostoLoaded) {
        this.fetchProducts()
      } else {
        this.eventBus.publish('category:shopify:products:fetched', {})
        console.error('Nosto failed to load within 5 seconds.')
      }
    })

    this.eventBus.subscribe('category:api:fetch:products', (data) => {
      this.fetchProducts(data?.targetPage, data?.direction)
    })

    this.eventBus.subscribe('category:tracking:product:clicked', (productData) => {
      nostojs(api => {
        api.recordSearchClick('category', {
          productId: productData.productId,
          url: productData.url,
        })
      })
    })

    this.eventBus.subscribe('category:tracking:product:added', (productData) => {
      const completeUrl = location.origin + productData.url
      nostojs(api => {
        api.recordSearchAddToCart('category', {
          productId: productData.productId,
          url: completeUrl,
        })
      })
    })
  }

  async waitForNostoJS () {
    return new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        if (window.nostojs) {
          clearInterval(checkInterval)
          resolve(true)
        }
      }, 100)

      setTimeout(() => {
        clearInterval(checkInterval)
        resolve(false)
      }, 5000)
    })
  }

  _calculatePaginationParams (currentPage) {
    const totalItemsPerPage = window.theme.categoryConfig.productsPerPage
    let apiSize = totalItemsPerPage
    let apiFrom = (currentPage - 1) * totalItemsPerPage
    let cumulativePromoSpanBeforeThisPage = 0

    const activeFacets = window.theme.category.stateLayer?.state?.activeFacets || []
    const applyPromoLogic = activeFacets.length === 0

    if (applyPromoLogic) {
      this.promos.forEach(promo => {
        const promoPosition = promo.position
        const promoSpan = promo.column_span || 1

        const promoStartPage = Math.floor((promoPosition - 1) / totalItemsPerPage) + 1

        if (promoStartPage < currentPage) {
          cumulativePromoSpanBeforeThisPage += promoSpan
        } else if (promoStartPage === currentPage) {
          apiSize -= promoSpan
        }
      })

      apiSize = Math.max(0, apiSize)

      apiFrom = Math.max(0, (currentPage - 1) * totalItemsPerPage - cumulativePromoSpanBeforeThisPage)
    }

    return { apiSize, apiFrom }
  }

  async fetchProducts (targetPage = null, direction = null) {
    try {
      nostojs(api => {
        api.defaultSession()
          .viewCategory(this.categoryPath)
          .load()
          .then(data => {})

        const currentPage = targetPage !== null ? targetPage : (window.theme.category.stateLayer?.state?.pagination?.currentPage || 1)

        const { apiSize, apiFrom } = this._calculatePaginationParams(currentPage)

        api.search(
          {
            products: {
              categoryId: this.categoryId,
              categoryPath: this.categoryPath,
              fields: ['name', 'imageUrl', 'alternateImageUrls', 'price', 'listPrice', 'url', 'skus.name', 'skus.id', 'skus.inventoryLevel'],
              size: apiSize,
              facets: ['*'],
              filter: window.theme.category.stateLayer?.state?.activeFacets || [],
              sort: window.theme.category.stateLayer?.state?.activeSort || [],
              from: apiFrom,
            },
          }, {
            track: 'category',
            redirect: true,
          },
        ).then(response => {
          this.eventBus.publish('category:api:products:fetched', response)

          const facets = response.products.facets
          if (facets) {
            this.eventBus.publish('category:api:facets:fetched', facets)
          }
        }).catch(error => {
          console.error('Failed to fetch products from Nosto:', error)
          this.eventBus.publish('category:shopify:products:fetched', {})
        })
      })
    } catch (error) {
      console.error('NostoJS API call failed:', error)
      this.eventBus.publish('category:shopify:products:fetched', {})
    }
  }

  get categoryId () {
    return document.querySelector('[data-category-id]').dataset.categoryId
  }

  get categoryPath () {
    return document.querySelector('[data-category-path]').dataset.categoryPath
  }
}

window.theme.category.apiLayer = new NostoAPILayer()
